module.exports = __webpack_public_path__ + "img/informatica-03.8c0bfa78.jpg";